/* eslint-disable */
import getApexCharts from "./apexcharts-shim.js";

function _typeof(obj) {
  return typeof obj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var ApexChartsComponent = {
  props: {
    options: { type: Object },
    type: { type: String },
    series: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    width: { default: "100%" },
    height: { default: "auto" },
  },
  data: function () {
    return { chart: null };
  },
  beforeMount: function () {
    var Chart = getApexCharts();
    if (typeof Chart === "function") {
      window.ApexCharts = Chart;
    }
  },
  mounted: function () {
    this.init();
  },
  created: function () {
    var _this = this;

    this.$watch("options", function (options) {
      if (!_this.chart && options) {
        _this.init();
      } else if (_this.chart) {
        _this.chart.updateOptions(_this.options);
      }
    });
    this.$watch("series", function (series) {
      if (!_this.chart && series) {
        _this.init();
      } else if (_this.chart) {
        _this.chart.updateSeries(_this.series);
      }
    });
    ["type", "width", "height"].forEach(function (prop) {
      _this.$watch(prop, function () {
        _this.refresh();
      });
    });
  },
  beforeDestroy: function () {
    if (this.chart) {
      this.destroy();
    }
  },
  render: function (createElement) {
    return createElement("div");
  },
  methods: {
    init: function () {
      var _this2 = this;
      var ApexCharts = getApexCharts();

      if (typeof ApexCharts !== "function") {
        console.error("[vue-apexcharts] ApexCharts constructor unavailable");
        return;
      }

      var newOptions = {
        chart: {
          type: (this.options && this.options.chart && this.options.chart.type) || this.type || "line",
          height: this.height,
          width: this.width,
          events: {},
        },
        series: this.series,
      };

      Object.keys(this.$listeners).forEach(function (evt) {
        newOptions.chart.events[evt] = _this2.$listeners[evt];
      });

      var config = this.extend(this.options || {}, newOptions);
      this.chart = new ApexCharts(this.$el, config);
      return this.chart.render();
    },
    isObject: function (item) {
      return item && _typeof(item) === "object" && !Array.isArray(item) && item != null;
    },
    extend: function (target, source) {
      var _this3 = this;
      var output = Object.assign({}, target || {});

      if (this.isObject(target) && this.isObject(source)) {
        Object.keys(source).forEach(function (key) {
          if (_this3.isObject(source[key])) {
            if (!(key in target)) {
              Object.assign(output, _defineProperty({}, key, source[key]));
            } else {
              output[key] = _this3.extend(target[key], source[key]);
            }
          } else {
            Object.assign(output, _defineProperty({}, key, source[key]));
          }
        });
      }

      return output;
    },
    refresh: function () {
      this.destroy();
      return this.init();
    },
    destroy: function () {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
    },
    updateSeries: function (newSeries, animate) {
      return this.chart.updateSeries(newSeries, animate);
    },
    updateOptions: function (newOptions, redrawPaths, animate, updateSyncedCharts) {
      return this.chart.updateOptions(newOptions, redrawPaths, animate, updateSyncedCharts);
    },
    toggleSeries: function (seriesName) {
      return this.chart.toggleSeries(seriesName);
    },
    showSeries: function (seriesName) {
      this.chart.showSeries(seriesName);
    },
    hideSeries: function (seriesName) {
      this.chart.hideSeries(seriesName);
    },
    appendSeries: function (newSeries, animate) {
      return this.chart.appendSeries(newSeries, animate);
    },
    resetSeries: function () {
      this.chart.resetSeries();
    },
    zoomX: function (min, max) {
      this.chart.zoomX(min, max);
    },
    toggleDataPointSelection: function (seriesIndex, dataPointIndex) {
      this.chart.toggleDataPointSelection(seriesIndex, dataPointIndex);
    },
    appendData: function (newData) {
      return this.chart.appendData(newData);
    },
    addText: function (options) {
      this.chart.addText(options);
    },
    addImage: function (options) {
      this.chart.addImage(options);
    },
    addShape: function (options) {
      this.chart.addShape(options);
    },
    dataURI: function () {
      return this.chart.dataURI();
    },
    setLocale: function (localeName) {
      return this.chart.setLocale(localeName);
    },
    addXaxisAnnotation: function (options, pushToMemory) {
      this.chart.addXaxisAnnotation(options, pushToMemory);
    },
    addYaxisAnnotation: function (options, pushToMemory) {
      this.chart.addYaxisAnnotation(options, pushToMemory);
    },
    addPointAnnotation: function (options, pushToMemory) {
      this.chart.addPointAnnotation(options, pushToMemory);
    },
    removeAnnotation: function (id, options) {
      this.chart.removeAnnotation(id, options);
    },
    clearAnnotations: function () {
      this.chart.clearAnnotations();
    },
  },
};

var VueApexCharts = ApexChartsComponent;

VueApexCharts.install = function (Vue) {
  var Chart = getApexCharts();
  Vue.ApexCharts = Chart;
  window.ApexCharts = Chart;
  Object.defineProperty(Vue.prototype, "$apexcharts", {
    get: function () {
      return getApexCharts();
    },
  });
};

export default VueApexCharts;
